<template>
	<div class="event-box" v-if='isShow'>
		<div class="mask"></div>
		<div class="event-content">
			<p class="titles">
				<span class="t_title">在线支持</span>
				<img @click="$emit('closeDialog')" :src="closeImg" class="closeImage" />
			</p>
			
			<div class="msvalue">
				<p class="keyword">查找内容：<span>{{ keyword }}</span></p>
				<table>
					<tr class="tableTitle">
						<th v-for="(column,r) in infoColumns" :key="r">{{column.name}}</th>
					</tr>
					<tr class="tablebody" v-for="l in parseInt(pageLen)" v-show="l <= 5 && l <= nowPage.length" :key="l">
						<template v-for="(column,r) in infoColumns">
							<td :key="r">{{getLabel(l-1,column,r)}}</td>
						</template>
					</tr>
				</table>
			</div>
			
			<div class="footer">
				<span @click="nowIndex - 1 >= 0?nowIndex-=1:''"><</span>
				<span v-show="indexType == 1 || indexType == 3">...</span>
				<span @click="nowIndex = item" v-for="item in pageIndexs" :class="{'nowselect':item == nowIndex}"
				 :key="item">{{item+1}}</span>
				<span v-show="indexType == 2 || indexType == 3">...</span>
				<span @click="nowIndex + 1 <= maxPageIndex?nowIndex+=1:''">></span>
			</div>
		</div>
	</div>
</template>

<script>
	// import infoList from '@/components/module/universal/infoList.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		// name: "infoListDialog",
		components: {
			// infoList
		},
		props: { 
			isShow: {
				type: Boolean,
				default: false
			},
			keyword: {
				type: String,
				default: undefined
			},
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			dataType: {
				type: Number,
				default: 0
			},
		},
		data(){
			return {
				closeImg: resourcesStore.getters.getResourcesByName('wedoButton/close.png'),
				infoColumns: [
					{
						name: "名称",
						key: "name"
					}, {
						name: "工作单位",
						key: "unit",
					}, {
						name: "技能",
						key: "skill"
					}, {
						name: "状态",
						key: "status"
					}
				],
				nowIndex: 0, //当前页码
				type: -1, //-1未初始化0没有多余页面1左边有多2右边有多3左右都有多
				nowCheckIndex: -1, //当前选中项,翻页就是-1
				pageLen: 5,
			}
		},
		mounted() {
		},
		computed: {
			totalSize() {
				if(!this.dataList){
					return 0
				}
				return this.dataList.length
			},
			maxPageIndex() {
				//根据长度计算出来的最大页码
				try {
					if (this.totalSize <= 0 || this.pageLen <= 0) {
						return 0
					}
					var max = this.totalSize / this.pageLen
					if (this.totalSize % this.pageLen == 0) {
						return (max | 0) - 1
					}
					return max | 0
				} catch (e) {
					return 0
				}
			},
			indexType() {
				if (this.maxPageIndex > 4) {
					if (this.nowIndex <= 2) {
						//显示从0开始,右边有多
						return 2
					} else if (this.nowIndex + 2 >= this.maxPageIndex) {
						//显示从右边开始,左边有多
						return 1
					} else {
						return 3
					}
				} else {
					//显示全部
					if (this.maxPageIndex == -1) {
						return -1
					} else {
						return 0
					}
				}
			},
			pageIndexs() {
				//显示出来的页码,只显示当前页的前和后2
				var list = []
				//页码足够多时,只显示当前页前4和后5共10页
				switch (this.indexType) {
					case -1:
						list.push(0)
						return
					case 0:
						for (var i = 0; i <= this.maxPageIndex; i++) {
							list.push(i)
						}
						break;
					case 1:
						for (var i = 4; i >= 0; i--) {
							list.push(this.maxPageIndex - i)
						}
						break;
					case 2:
						for (var i = 0; i <= 4; i++) {
							list.push(i)
						}
						break;
					case 3:
						for (var i = this.nowIndex - 2; i <= this.nowIndex + 2; i++) {
							list.push(i)
						}
						break;
				}
				return list
			},
		},
		watch: {
			dataList(){
				if(this.dataList){
					this.nowPage = this.dataList.slice(0,5)
				}else{
					this.nowPage = []
				}
			},
			nowIndex(nv, ov) {
				if(nv*5 > this.dataList.length){
					this.nowPage = this.dataList.slice(nv*5, this.dataList.length)
				}else{
					this.nowPage = this.dataList.slice(nv*5, (nv+1)*5)
				}
			},
			
			maxPageIndex(nv, ov) {
				if (this.nowIndex > 0) {
					this.nowIndex = 0
				}
			}
		},
		methods: {
			getLabel(index, column, columnIndex) {
				//获取第l行第r格的内容
				if (this.nowPage[index] == undefined) {
					return ''
				}
				var data
				if (this.dataType == 1) {
					//数组型数据
					data = this.nowPage[index][columnIndex]
				} else {
					//默认键值对型数据
					data = this.nowPage[index][column.key]
				}
				if (data == undefined) {
					return ''
				}
				if (column.format != undefined) {
					//数据需要经过处理
					return column.format(data,this.nowPage[index])
				}
				return data
			},
			getTdStyleMethod(column, index, value) {
				var sty = {
					'overflow': 'hidden',
					/*超过部分不显示*/
					'text-overflow': 'ellipsis',
					/*超过部分用点点表示*/
					'white-space': 'nowrap',
					/*不换行*/
				}
				if (column.getTdStyleMethod != undefined) {
					try {
						Object.assign(sty, column.getTdStyleMethod(column, index, value))
					} catch (e) {
						err(e.stack)
					}
				}
				return sty
			},
			
			// openInfoListDialog(title, dataList, keyword, infoColumns) {
			// 	this.title = title
			// 	this.dataList = dataList
			// 	this.nowPage = dataList.slice(0,5)
			// 	this.keyword = keyword
			// 	this.infoColumns = infoColumns
			// 	this.totalSize = dataList.length
			// 	this.isShow = true
			// },
		}
	}
</script>

<style scoped>
	
	.event-box {
		position: absolute;
		width: auto;
		height: auto;
	}

	.event-box .mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}

	.event-box .event-content {
		z-index: 999;
		position: fixed;
		top: 0%;
		left: 0;
		right: 0;
		margin: auto;
		width: 8rem;
		padding: 0;
		background-color: rgb(42,88,200);
		border-radius: .06rem;
		color: white;
		margin-top: .7rem;
		text-align: left;
		padding: 0.2rem;
		height: 57%;
		opacity: 0.9;
	}
	
	.event-box .t_title {
		float: left;
		color: white;
		font-size: .18rem;
		font-weight: 400;
	}

	.event-box .closeImage {
		float: right;
		width: .2rem;
		height: .2rem;
		cursor: pointer;
	}

	.event-box .event-content .titles {
		color: white;
		margin-bottom: .15rem;
		font-weight: 1000;
		height: 20px;
	}

	.event-box .event-content .msvalue{
		min-height: 1rem;
		height: calc(100% - 0.51rem);
		overflow: hidden;
		overflow-y: auto;
	}
	
	.event-box .event-content .keyword{
		font-size: 16px;
		color: white;
		text-align: left;
		padding-left: .2rem;
		margin-bottom: .15rem;
	}
	.event-box .event-content .keyword span{
		font-size: 16px;
		color: #FFCC33;
	}
	table{
		border-collapse: collapse; 
		width: 100%;
	}
	table .tableTitle{
		border-top: 1px solid #D6D6D6;
		border-bottom: 1px solid #D6D6D6;
	}
	table .tablebody{
		border-bottom: 1px solid #D6D6D6;
	}
	
	table th,td{
		color: white;
		padding: .1rem;
	}
	.event-box .event-content .footer{
		float: right;
	}
	.event-box .event-content .footer span{
		color: white;
		padding: .1rem;
	}
	.event-box .event-content .footer .nowselect{
		color: #6BBFFF;
	}
</style>
